import { Outlet } from 'react-router';
import ReleaseIdCardSearchPersonPage from 'front-office/pages/release-id-card/search';
import { RoutesConfig } from 'shell/router/routes-config';
import { NotFound } from 'shell/error/components/error-not-found';
import ReleaseIdCardPage from 'front-office/pages/release-id-card/release';
import ReprintCidPage from 'front-office/pages/reprint-cid';
import RegisterIdCardSearchPersonPage from 'front-office/pages/registration-id-card/search';
import RegisterIdCardPage from 'front-office/pages/registration-id-card/registration';
import CancellationIdCardSearchPersonPage from 'front-office/pages/cancellation-id-card/search';
import CancellationIdCardPage from 'front-office/pages/cancellation-id-card/cancellation';
import LotsManagementList from 'front-office/pages/lots-management/list';
import LotsManagementNew from 'front-office/pages/lots-management/new';
import LotsManagementEdit from 'front-office/pages/lots-management/edit';
import RetrieveIdCardList from 'front-office/pages/retrieve-id-card/list';
import {
  FrontOfficeAuthorizations,
  RegistrationIDCardAuthorizations,
  AnnullamentIDCardAuthorizations,
  ReleaseIdCardAuthorizations,
  ReprintCidAuthorizations,
  RetrieveIdCardAuthorizations,
} from 'shell/authorizations/front-office';
import LotsManagementDetail from 'front-office/pages/lots-management/detail';
import ReprintCidSearchPerson from 'front-office/pages/reprint-cid/search-person';

export const cardRoutes: RoutesConfig = [
  {
    name: "Carta d'identità",
    path: '',
    element: <Outlet />,
    hidden: true,
    children: [
      {
        path: '',
        hidden: true,
      },
      {
        path: '/rilascio-carta',
        name: 'Rilascio carta',
        authorizations: ReleaseIdCardAuthorizations,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <ReleaseIdCardSearchPersonPage />,
          },
          {
            path: '/rilascio',
            element: <ReleaseIdCardPage />,
          },
        ],
      },
      {
        path: '/ristampa-carta/ricerca-persona',
        name: 'Stampa busta CIE',
        authorizations: ReprintCidAuthorizations,
        children: [
          {
            path: '',
            element: <ReprintCidSearchPerson />,
          },
          {
            path: '/ristampa',
            element: <ReprintCidPage />,
          },
        ],
      },
      {
        path: '/registrazione-carta',
        name: 'Registrazione Carta',
        authorizations: RegistrationIDCardAuthorizations,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <RegisterIdCardSearchPersonPage />,
          },
          {
            path: '/registra',
            element: <RegisterIdCardPage />,
          },
        ],
      },
      {
        path: '/annullamento-carta',
        name: 'Annullamento Carta',
        authorizations: AnnullamentIDCardAuthorizations,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <CancellationIdCardSearchPersonPage />,
          },
          {
            path: '/annulla',
            element: <CancellationIdCardPage />,
          },
        ],
      },
      {
        path: '/gestione-lotti',
        name: 'Gestione Lotti',
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <LotsManagementList />,
            authorizations: [FrontOfficeAuthorizations.RicercaLotti],
          },
          {
            path: '/nuovo',
            element: <LotsManagementNew />,
            authorizations: [FrontOfficeAuthorizations.ModificaLotti],
          },
          {
            path: '/modifica',
            element: <LotsManagementEdit />,
            authorizations: [FrontOfficeAuthorizations.ModificaLotti],
          },
          {
            path: '/dettaglio',
            element: <LotsManagementDetail />,
            authorizations: [FrontOfficeAuthorizations.RicercaLotti],
          },
        ],
      },
      {
        path: '/recupero-cie',
        name: 'Recupero Cartellini CIE',
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <RetrieveIdCardList />,
            authorizations: RetrieveIdCardAuthorizations,
          },
        ],
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];
